module.exports = __webpack_public_path__ + "static/media/cocorobolixianban2.155fd00b.png";